import cs from 'classnames';
import styles from './footer.module.scss';
import { Description } from './description';
import { LanguageSelector } from '../../molecules';
import { Info } from '../../../../../widgets';
import { FooterNavigationBar } from './navigation-bar';
import { LegalLinks } from '../../molecules/legal-links';
import { AdTech } from '../../molecules/AdTech';
import { TileInfo } from './tile-info/tile-info';
import { useTranslation } from 'react-i18next';

export const Footer = (): JSX.Element => {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  return (
    <footer className={cs(styles['wrapper'])}>
      <Info />
      <div className={cs(styles['content'])}>
        <div className={cs(styles['links'])}>
          <LanguageSelector />
          <FooterNavigationBar />
        </div>
        <Description />

        {locale === 'ru' && (
          <>
            <AdTech />
            <div className={cs(styles['legalLinks'])}>
              <LegalLinks />
            </div>
          </>
        )}

        <div className={cs(styles['tile-wrapper'])}>
          <TileInfo />
        </div>
      </div>
    </footer>
  );
};
